module.exports = __webpack_public_path__ + "static/media/cam-2.png";